import { useTranslation } from "react-i18next"
import { useQuery } from "react-query"
import { FormQueryKeys } from "../constants/FormQueryKeys"
import { DataBaseService } from "../services/DatabaseService"
import { LanguageOption } from "../types/LanguageOption"

export function useGetFormByProvince(province: string) {
  const { i18n } = useTranslation()

  const language = i18n.resolvedLanguage as LanguageOption

  const { data, isLoading, error } = useQuery(
    FormQueryKeys.byProvinceAndLanguage(province, language),
    () => DataBaseService.getFormByProvince(province, language),
    { useErrorBoundary: true },
  )
  return { data, isLoading, error }
}
